import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./tailwind.css";

import App from "./App";
import { PublicVenuePage } from "./components/PublicVenuePage";
import { InstallScreen } from "./components/InstallScreen";
import { CollectScreen } from "./components/CollectScreen";
import { EventsLanding } from "./components/EventsLanding";
import { UpdatePill } from "./components/UpdatePill";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Public shareable venue card: flanit.co/v/<id> renders a standalone, no-login
// card (the heavy app never mounts). flanit.co/install renders the app-store
// style install landing (QR on desktop, device-aware steps on mobile).
// Anything else → the app.
const publicVenue = window.location.pathname.match(/^\/v\/(\d+)/);
const installPage = /^\/install\/?$/.test(window.location.pathname);
// Collect link: flanit.co/c/<token> — guest photo drop for a check-in.
const collectPage = window.location.pathname.match(/^\/c\/([A-Za-z0-9_-]+)/);
// Organiser landings (Aug 30): /weddings = wedding framing (Say I Do links
// here — source IS intent), /events = generic skin. Same component.
const landingPage = window.location.pathname.match(/^\/(weddings|events)\/?$/);

// THE HOMEPAGE LIVES AT "/" NOW (Oct 15) — the old client-side redirect to
// /home/ is gone. Edge middleware (middleware.js) serves /home/index.html
// AT "/" for visitors without the flanit_in cookie; members with the cookie
// get this app. The cookie is set/cleared by App.js's auth listener, and
// the homepage self-heals it for signed-in users who lost it.

// Keep the push service worker alive across visits (push-only SW — it never
// intercepts fetches, so it can't serve stale bundles).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(() => {});
}

root.render(
  <StrictMode>
    {/* Renders on every surface — a stale bundle announces itself. */}
    <UpdatePill />
    {publicVenue ? (
      <PublicVenuePage venueId={publicVenue[1]} />
    ) : installPage ? (
      <InstallScreen />
    ) : collectPage ? (
      <CollectScreen token={collectPage[1]} />
    ) : landingPage ? (
      <EventsLanding variant={landingPage[1]} />
    ) : (
      <App />
    )}
  </StrictMode>
);
